import styled from 'styled-components';

export const Wrapper = styled.div`
  &.on-truck-page {
    margin-right: auto;

    @media screen and (min-width: 481px) {
      .confirmPopover {
        margin-top: 35px;
      }
    }
  }

  &.in-card {
    margin-left: 13px;

    @media screen and (max-width: 1023px) {
      margin-left: auto;
      order: 3;
    }
  }

  .confirmPopover {
    max-width: 220px;

    @media screen and (max-width: 480px) {
      max-width: none;
      z-index: 10001;
    }
  }

  .popover-content {
    display: flex;
    flex-direction: column;
  }

  .popover-text {
    padding-top: 6px;
    font-size: ${({ theme }) => theme.fontSize.sm};
  }

  .popover-btn {
    padding-top: 10px;
  }
`;

export const ActionButton = styled.div`
  display: flex;

  && button {
    padding-left: 12px;
    padding-right: 12px;
    letter-spacing: 0.8px;
  }

  .delete-text {
    padding-left: 5px;

    @media screen and (min-width: 1024px) {
      display: none;
    }

    @media screen and (max-width: 479px) {
      display: flex;
    }

    @media screen and (max-width: 350px) {
      display: none;
    }
  }
`;

export const TooltipContainer = styled.div`
  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const HeaderPopover = styled.div`
  padding-bottom: 10px;
`;
